import { Button, HakimoSpinner } from '@hakimo-ui/shared/ui-base';

interface Props {
  isLoading: boolean;
  isError: boolean;
  hasIncident: boolean;
  onRetry: () => void;
}

/**
 * The loading / failed / empty states for the incident details page. Rendered
 * in place of the page body; returns null once there is an incident to show.
 */
export function IncidentDetailsStates({
  isLoading,
  isError,
  hasIncident,
  onRetry,
}: Props) {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center p-6">
        <HakimoSpinner />
      </div>
    );
  }

  // A failed request is not an absent incident — saying "not found"
  // here has sent operators off to re-escalate a live alarm.
  if (isError) {
    return (
      <div className="flex flex-col items-center gap-3 p-6 text-center">
        <p className="text-onlight-text-2 dark:text-ondark-text-2">
          Could not load this incident. The request failed.
        </p>
        <Button variant="primary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (!hasIncident) {
    return (
      <div className="p-6 text-center">
        <p className="text-onlight-text-2 dark:text-ondark-text-2">
          No incident found for this alarm.
        </p>
      </div>
    );
  }

  return null;
}

export default IncidentDetailsStates;
